import { render, staticRenderFns } from "./MessagePlainTextBody.vue?vue&type=template&id=19777a7e&scoped=true"
import script from "./MessagePlainTextBody.vue?vue&type=script&lang=js"
export * from "./MessagePlainTextBody.vue?vue&type=script&lang=js"
import style0 from "./MessagePlainTextBody.vue?vue&type=style&index=0&id=19777a7e&prod&lang=scss"
import style1 from "./MessagePlainTextBody.vue?vue&type=style&index=1&id=19777a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19777a7e",
  null
  
)

export default component.exports